import React from 'react'
import ComingSoon from '../../components/comingSoon/ComingSoonPage'

const LogsPage = () => {
  return (
<>
<ComingSoon/>
</>  )
}

export default LogsPage